import React from 'react';
import styled from 'styled-components';
import Icon from '@minecraft.icon';

const StyledAppearanceInfo = styled.div`
  display: flex;
  align-items: center;
  margin: 1rem 0;
  padding: 0.125rem 0.375rem;
  font-size: 0.85rem;
  background: ${(props) => props.theme.colors.accent.greyBlue2};
`;

const StyledIconWrapper = styled.div`
  height: 1.5rem;
  width: 1.5rem;
  margin-right: 0.5rem;
`;

type Props = {
  'data-qa-id'?: string;
  children: React.ReactNode;
  className?: string;
};

const AppearanceInfo = ({ 'data-qa-id': qaId, children, className }: Props) => (
  <StyledAppearanceInfo
    data-testid="profile-visibility-alert"
    data-qa-id={`${qaId}-visibility-message`}
    className={className}
  >
    <StyledIconWrapper>
      <Icon data-qa-id={`${qaId}-visibility-off-icon`} name="visibility-off" themeColor="active" />
    </StyledIconWrapper>

    <div>{children}</div>
  </StyledAppearanceInfo>
);

export default AppearanceInfo;
